import { useMemo } from 'react';
import interCoderMapper from '../mappers/intercoder/InterCoderMapper';

/**
 * Hook to calculate intercoder reliability score
 * @param {Array} excerpts - Array of excerpt objects with codings
 * @returns {Object} Object containing score and user_count
 */
export function useIntercoderScore(excerpts) {
  const result = useMemo(() => {
    if (!excerpts || !Array.isArray(excerpts)) {
      return {
        score: NaN,
        user_count: 0
      };
    }

    // Call the mapper with excerpts
    const { score, user_count } = interCoderMapper(excerpts);

    return {
      score,
      user_count
    };
  }, [excerpts]);

  return result;
}